import type { ReviewConfig, ReviewResult } from './serviceExecutionApi';

export const baseStudyFields: Record<string, string> = { DESIGN: 'Дизайн', POPULATION: 'Выборка', METHOD: 'Метод', OUTCOME: 'Результат' };
export const studyKey = (value: string) => value.normalize('NFC').trim().replace(/\s+/gu, ' ');
export const studyFields = (config: ReviewConfig): Record<string, string> => ({ ...baseStudyFields, ...Object.fromEntries((config.custom_fields || []).map((name) => [name, name])) });

export function studyGroups(result: ReviewResult) {
  const groups = new Map<string, { id: string; reports: ReviewResult['records']; fields: Map<string, Set<string>>; conflicts: string[]; resolution: string }>();
  for (const record of result.records) {
    if (record.decision !== 'ADVANCE' || record.full_text_decision !== 'INCLUDE') continue;
    const key = result.config.group_reports ? studyKey(record.study_id || '') : record.id;
    if (!key) continue;
    const group = groups.get(key) || { id: key, reports: [], fields: new Map<string, Set<string>>(), conflicts: [], resolution: Object.prototype.hasOwnProperty.call(result.study_resolutions || {}, key) ? result.study_resolutions![key] : '' };
    group.reports.push(record);
    for (const finding of record.findings || []) {
      const values = group.fields.get(finding.field) || new Set<string>();
      values.add(studyKey(finding.value));
      group.fields.set(finding.field, values);
    }
    groups.set(key, group);
  }
  for (const group of groups.values()) group.conflicts = [...group.fields].filter(([, values]) => values.size > 1).map(([field]) => field);
  return [...groups.values()];
}

export function studiesReady(result: ReviewResult) {
  if (result.records.some((record) => result.config.group_reports && record.decision === 'ADVANCE' && record.full_text_decision === 'INCLUDE' && (!studyKey(record.study_id || '') || !record.study_reason?.trim()))) return false;
  const groups = studyGroups(result);
  if (Object.keys(result.study_resolutions || {}).some((key) => !result.config.group_reports || !groups.some((group) => group.id === key))) return false;
  return groups.every((group) => (!result.config.group_reports || !group.conflicts.length || group.resolution.trim()) && (result.config.required_fields || []).every((field) => group.fields.has(field)));
}
